import { useState } from 'react';
import { mixpanelTrack } from '@providers/Mixpanel';
import { STEP_STATUS, WORKFLOW_TRIGGERS, WorkflowStep } from '@typings/api-models';
import Buttons from '@components/Buttons';
import ProgressIndicator from '@components/ProgressIndicator';
import isStepCompleted from '@helpers/isStepCompleted';
import canRetriggerStep from '@helpers/canRetriggerStep';

type Props = {
  step: Pick<WorkflowStep, 'eventName' | 'id'> & {
    stepTaken?: { status: STEP_STATUS } | null;
    data: unknown;
  };
  isCreatorView: boolean;
  buttonText?: string;
  onClick: (stepId: string) => Promise<void>;
  className?: string;
};

const TriggerCTAButton: React.FC<Props> = ({ isCreatorView, onClick, step, buttonText, className }) => {
  const [isTriggering, setIsTriggering] = useState(false);

  const handleClick = async (): Promise<void> => {
    mixpanelTrack('Workflow - trigger CTA', { isCreatorView, stepId: step.id });
    setIsTriggering(true);
    await onClick(step.id);
    setIsTriggering(false);
  };

  const showButton = (
    step.eventName === WORKFLOW_TRIGGERS.USER_WORKFLOW_CTA
    && isCreatorView
    && (!isStepCompleted(step) || canRetriggerStep(step))
  );

  if (!showButton) {
    return null;
  }

  if (isTriggering) {
    return <ProgressIndicator size={14} />;
  }

  return (
    <Buttons isWrapper isFetching={isTriggering} onClick={handleClick} className={className}>
      {buttonText || 'Trigger Step'}
    </Buttons>
  );
};

export default TriggerCTAButton;